import { useMutation, useQueryClient } from '@tanstack/react-query'
import api from '../../api'
import type { MongoDBApprovalRequest } from '../../types/mongodb'

const useAcceptMongoDB = (mongoDBID: string) => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: (request: MongoDBApprovalRequest) =>
			api.mongodb.approveMongoDB(request),
		onSuccess: () => {
			void queryClient.invalidateQueries({ queryKey: ['mongodb'], exact: true })
			void queryClient.invalidateQueries({ queryKey: ['mongodb', mongoDBID] })
			void queryClient.invalidateQueries({ queryKey: ['mongodb-eligibility'] })
		}
	})
}

export default useAcceptMongoDB
